import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs/Rx';

@Injectable()
export class ModalEmailService {
    public subject = new Subject();
    public openModalListener$ = this.subject.asObservable();
    constructor() { }

    public getModalListener(){
        return this.openModalListener$;
    }

    public openModalEmail(value){
        this.subject.next(value);
    }
}


// WEBPACK FOOTER //
// ./src/app/common/modal-email/modal-email.service.ts